import { render, staticRenderFns } from "./PopupInstrucoes.vue?vue&type=template&id=74886648&scoped=true"
import script from "./PopupInstrucoes.vue?vue&type=script&lang=js"
export * from "./PopupInstrucoes.vue?vue&type=script&lang=js"
import style0 from "./PopupInstrucoes.vue?vue&type=style&index=0&id=74886648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74886648",
  null
  
)

export default component.exports